/**
 * Instrument Library service - read-only API calls for the funding instrument catalog.
 */
import api from './api';
import { ApiResponse } from '../types';
import {
  InstrumentLibraryItem,
  InstrumentListFilters,
  InstrumentListResponse,
} from '../types/project';

export async function fetchInstruments(
  filters?: InstrumentListFilters
): Promise<ApiResponse<InstrumentListResponse>> {
  try {
    const response = await api.get('/instruments', { params: filters });
    const payload = response.data;
    if (Array.isArray(payload)) {
      return { data: { instruments: payload, total: payload.length } };
    }
    return {
      data: {
        instruments: payload?.instruments || [],
        total: payload?.total ?? 0,
      },
    };
  } catch (error: any) {
    return { error: error.response?.data?.detail || 'Failed to load instruments' };
  }
}

export async function fetchInstrument(
  instrumentType: string
): Promise<ApiResponse<InstrumentLibraryItem>> {
  try {
    const response = await api.get(`/instruments/${instrumentType}`);
    return { data: response.data };
  } catch (error: any) {
    return { error: error.response?.data?.detail || 'Failed to load instrument' };
  }
}

const instrumentService = {
  fetchInstruments,
  fetchInstrument,
};

export default instrumentService;
